import { Controller } from 'react-hook-form';
import { NativeSelect } from '@mantine/core';
import { TbChevronDown } from 'react-icons/tb';
import { useMemo } from 'react';

export function FormSelect({
  name,
  control,
  label,
  required = false,
  options = [],
  disabled = false,
  id
}) {
  const customOptions = useMemo(() => {
    return [{ value: '', label: '' }, ...options];
  }, [options]);

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) => (
        <NativeSelect
          id={id}
          label={label}
          value={value || ''}
          onChange={onChange}
          disabled={disabled}
          data={customOptions}
          required={required}
          rightSection={<TbChevronDown size={16} />}
        />
      )}
      name={name}
    />
  );
}
